import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';

// Counter to track active HTTP requests
let activeRequests = 0;

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(NgxSpinnerService);

  // Increment counter when request starts
  activeRequests++;

  // Show spinner when first request starts
  // Note: Spinner should already be shown in APP_INITIALIZER or constructor
  // This ensures it stays visible during API calls
  if (activeRequests === 1) {
    // Use requestAnimationFrame in browser; fallback for SSR (Node has no requestAnimationFrame)
    const scheduleShow =
      typeof requestAnimationFrame !== 'undefined'
        ? requestAnimationFrame
        : (cb: () => void) => setTimeout(cb, 0);
    scheduleShow(() => spinner.show());
  }

  return next(req).pipe(
    finalize(() => {
      // Decrement counter when request completes
      activeRequests--;

      // Hide spinner only when all requests are complete
      if (activeRequests === 0) {
        // Add small delay to ensure smooth transition
        setTimeout(() => {
          spinner.hide();
        }, 100);
      }
    }),
  );
};
